<template>
  <v-container
    class="auth"
    fill-height
    container--fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        lg4
        md5
        :class="!$vuetify.breakpoint.xs ? 'mt-5' : ''"
      >
        <center>
          <v-img
            :src="logo"
            :lazy-src="logo"
            :max-width="logoMaxWidth"
            contain
          />
        </center>
       
        <v-card
          raised
        >
          <v-form
            v-if="!submitted"
            @submit.prevent="Register"
          >
            <v-layout
              wrap
            >
              <v-flex
                xs12
                md12
              >
                <h3>{{ $t('register.joiningUs') }}</h3>
                {{ $t('register.createAccount') }}
               
                <span v-if="$route.query.email !== undefined && form.email != ''">
                  <br> <br><small>{{ $t('globals.email') }}:</small><br>
                  <b>{{ form.email }}</b>
                </span>
                <v-text-field
                  id="name"
                  v-model.trim="form.name"
                  class="mt-5"
                  :error-messages="NameErrors"
                  name="name"
                  :label="$t('globals.name') +'*'"
                  required
                  @input="$v.form.name.$touch()"
                  @blur="$v.form.name.$touch()"
                >
                  <template v-slot:append>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <small v-on="on">{{ $t('profile.phoneWhy') }}</small>
                      </template>
                      {{ $t('profile.nameWhyTooltip') }}
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
              <v-flex
                v-show="!($route.query.email !== undefined && form.email != '')"
                xs12
                md12
              >
                <v-text-field
                  id="email"
                  v-model.trim="form.email"
                  :error-messages="EmailErrors"
                  autocomplete="email"
                  name="email"
                  :label="$t('globals.email') +'*'"
                  required
                  @input="$v.form.email.$touch()"
                  @blur="$v.form.email.$touch()"
                />
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-text-field
                  id="password"
                  v-model.trim="form.password"
                  :error-messages="PasswordErrors"
                  autocomplete="current-password"
                  name="password"
                  :label="$t('globals.password') +'*'"
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  required
                  @click:append="showPassword = !showPassword"
                  @input="$v.form.password.$touch()"
                  @blur="$v.form.password.$touch()"
                />
              </v-flex>  
              <v-flex
                v-show="userAgreement"
                xs12
                md12
              >
                <v-checkbox
                  v-model="form.acceptterms"
                  :error-messages="AcceptTermsErrors"
                  color="primary"
                  @change="$v.form.acceptterms.$touch()"
                >
                  <template
                    v-slot:label
                  >
                    <span
                      style="font-size:13px;display:inline-block;line-height:16px;"
                    >
                      {{ $t('register.iAgreee') }}
                      <a
                        target="_blank"
                        :href="userAgreement"
                        @click.stop
                      >{{ $t('register.termsOfUse') }}</a>
                    </span>
                  </template>
                </v-checkbox>
              </v-flex>
              <v-flex
                v-if="siteCaptchaKey && _.isString(siteCaptchaKey)"
                xs12
                class="text-center"
              >
                <CloudFrontVerification
                  :sitekey="siteCaptchaKey"
                  @verify="verifyCaptcha"
                />
              </v-flex>
              <v-flex
                mt-5
                xs12
              >
                <v-btn
                  class="primary"
                  block
                  x-large
                  :disabled="loading"
                  :loading="loading"
                  @click="Register"
                >
                  {{ $t('register.buttonCreateAccount') }}
                </v-btn>
              </v-flex>
              <v-flex
                xs12
                :class="$vuetify.breakpoint.xs ? 'text-center' : 'text-right'"
              >
                <v-icon
                  style="font-size:16px; margin-right:3px;"
                  color="success"
                >
                  mdi-lock
                </v-icon>
                <small>{{ $t("register.ssl") }}</small> 
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout 
            v-if="submitted"
            wrap
          >
            <v-flex
              verification
              xs12
              md12
            >
              <v-icon class="main-icon">
                mdi-email-outline
              </v-icon>
              <h2> {{ $t('register.emailVer') }}</h2>
              <h5>
                {{ $t('register.sentEmail1') }} 
                <strong>{{ form.email | makeHidden }}</strong>
              </h5>
              <center style="padding:10px;margin:30px 0 40px;">
                <countdown
                  :time="countDownTime"
                  :transform="transform"
                  @end="handleCountDownEnd"
                >
                  <template slot-scope="props">
                    <span>
                      {{ $t('register.notConfirmed') }}&nbsp;&nbsp;<v-icon style="margin-top:-2px;color:red;">mdi-clock-outline</v-icon>
                      &nbsp;&nbsp;<b>{{ props.minutes }}:{{ props.seconds }}</b>
                    </span>
                  </template>
                </countdown>
              </center>
              
              <email-hints />
            </v-flex>
          </v-layout>
        </v-card>
        <v-flex
          v-if="!submitted"
          xs12
          text-center
        >
          <small>
            {{ $t('register.alreadyRegistered') }}
            <router-link to="/login">{{ $t('register.logIn') }}</router-link> 
          </small>
        </v-flex>
      </v-flex>
    </v-layout>  
  </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
import EmailHints from '@/views/Auth/partial/EmailHints.vue'
import VueCountdown from "@chenfengyuan/vue-countdown";
import CloudFrontVerification from "@/views/Auth/partial/CloudFrontVerification.vue";

const good_password = value => /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value)

export default {
  name: 'Register',
  components: {
    CloudFrontVerification,
    EmailHints,
    countdown: VueCountdown,
  },
  mixins: [validationMixin],
  data() {
    return  {
      logoLight: this.$ls.get('config').logo_light_theme,
      logoDark: this.$ls.get('config').logo_dark_theme,
      showPassword: false,
      loading: false,
      error: false,
      submitted: false,
      siteCaptchaKey: process.env.VUE_APP_TURNSTILE_KEY,
      form: {
          name: '',
          email: '',
          password: '',
          acceptterms: false,
          tokenCaptcha: ''
      }
    }
  },
  validations () {
    return {
      form: this.rules
    }
  },
  computed: {
    logo() {
      return this.$vuetify.theme.dark ? this.logoDark : this.logoLight
    },
    countDownTime() {
      let time = 120 * 1000;
      return time > 0 ? time : 0;
    },
    userAgreement() {
      const config = this.$ls.get('config')
      if (config && config.public_config && config.public_config.user_agreement_link) {
        return config.public_config.user_agreement_link
      }
      return null
    },
    logoMaxWidth() {
      const config = this.$ls.get('config')
      if (config && config.public_config && config.public_config.app_auth_logo_max_width) {
        return config.public_config.app_auth_logo_max_width
      }
      return null
    },
    rules () {
      var form = {
        name: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(255),
        },
        email: {
            required,
            email,
            maxLength: maxLength(255),
        },
        password: {
            required,
            minLength: minLength(8),
            maxLength: maxLength(255),
            good_password
        },
        acceptterms: {
            checked (value) {
                return value
            }
        }
      }
      return form
    },
    NameErrors () {
      const errors = []
      if (!this.$v.form.name.$dirty) return errors
      !this.$v.form.name.required &&
        errors.push(this.$t('register.reqName'));
      (!this.$v.form.name.minLength ||
      !this.$v.form.name.maxLength) &&
        errors.push(this.$t('register.mustName'));
      return errors
    },
    EmailErrors () {
      const errors = []
      if (!this.$v.form.email.$dirty) return errors
      !this.$v.form.email.required &&
        errors.push(this.$t('register.reqEmail'))
      !this.$v.form.email.email &&
        errors.push(this.$t('register.validEmail')) 
      !this.$v.form.email.maxLength &&
        errors.push(this.$t('register.mustEmail'))
      return errors
    },
    PasswordErrors () {
      const errors = []
      if (!this.$v.form.password.$dirty) return errors
      !this.$v.form.password.required &&
        errors.push(this.$t('register.reqPassword'))
      !this.$v.form.password.maxLength &&
        errors.push(this.$t('register.maxPassword'))  
      !this.$v.form.password.good_password &&
        errors.push(this.$t('register.mustPassword'))  
      return errors
    },
    AcceptTermsErrors () {
      const errors = []
      if (!this.$v.form.acceptterms.$dirty) return errors
      !this.$v.form.acceptterms.checked &&
        errors.push(this.$t('register.acceptTerms'))
      return errors
    }
  },
  mounted() {
    if (this.$route.params.id !== undefined 
      && this.$route.params.id.length === 10) {
        this.$cookie.set("sp", this.$route.params.id, { expires: '1M' });
    }
    if (this.$route.query.email !== undefined) {
      this.form.email = this.$route.query.email 
      if (this.$v.form.email.$invalid) {
         this.form.email = ""
      }
    }
  },
  methods: {
    verifyCaptcha(token) {
      this.form.tokenCaptcha = token;
    },
    Register() {
      if (!this.userAgreement) {
        this.form.acceptterms = true
      }
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true;
        this.$apollo.mutate({
            mutation: require('@/graphql/mutations/CreateUser.gql'),
            variables: {
                name: this.form.name,
                email: this.form.email,
                password: this.form.password,
                lang: this.$i18n.locale,
                phine: this.form.phone,
                sponsor: this.$cookie.get('sp') || null,
                source: this.$ls.get('config').source,
                turnstile_token: this.form.tokenCaptcha
            }
        }).then(data => {
            this.submitted = true;
            this.loading = false;
        }).catch(error => {
            this.errorHandler(error)
            this.loading = false;
        })
      }
    },
    handleCountDownEnd() {},
    transform(props) {
      Object.entries(props).forEach(([key, value]) => {
        const digits = value < 10 ? `0${value}` : value;
        props[key] = `${digits}`;
      });
      return props;
    },
  }
}
</script>

<style lang="scss">

.v-input--checkbox {
  .error--text {
    margin-top:25px;
  }
}

</style>
